<template>
  <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
    <vx-card>
      <h2
        :class="{'text-success': device.status == 1, 'text-danger': device.status == 0}"
      >{{device.alias || 'Sem Apelido'}}</h2>

      <div class="my-6">
        <vs-button
          icon-pack="feather"
          icon="icon-x-circle"
          color="danger"
          class="w-full"
          :disabled="true"
          v-if="device.status == 0"
        >Excluído/Expirado</vs-button>

        <vs-button
          icon-pack="feather"
          icon="icon-edit"
          color="success"
          class="w-full"
          v-else-if="device.status == 1"
          @click="editLicence(device)"
        >Editar Licença</vs-button>
      </div>

      <div class="my-6">
        <h5 class="mb-2">{{device.licencekey}}</h5>
        <p>Licença</p>
      </div>
      <div class="my-6">
        <h5 class="mb-2 text-success" v-if="device.status == 1">Sim</h5>
        <h5 class="mb-2 text-danger" v-if="device.status == 0">Não</h5>
        <p>Licença Ativa</p>
      </div>
      <div class="my-6">
        <h5 class="mb-2">{{device.updated_at | formatDateTime}}</h5>
        <p>Última Atualização</p>
      </div>
      <div class="my-6">
        <h5 class="mb-2">{{device.licence_valid_until | formatDate}}</h5>
        <p>Validade Licença</p>
      </div>
      <vs-divider></vs-divider>
      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Sites</p>
        <p>Quantidade</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_httptraffic">{{device.last_update_httptraffic | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_httptraffic}}</p>
      </div>
      <vs-divider></vs-divider>
      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Teclas</p>
        <p>Quantidade</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_keylogger">{{device.last_update_keylogger | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_keylogger}}</p>
      </div>
      <vs-divider></vs-divider>
      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Telas</p>
        <p>Quantidade</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_screenshot">{{device.last_update_screenshot | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_screenshot}}</p>
      </div>
      <vs-divider></vs-divider>
      <div class="flex justify-between flex-wrap">
        <p class="font-bold">Pesquisas</p>
        <p>Quantidade</p>
      </div>
      <div class="flex justify-between flex-wrap">
        <p v-if="device.last_update_search">{{device.last_update_search | formatDateTime}}</p>
        <p v-else>-</p>
        <p>{{device.count_search}}</p>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  props: ['device', 'editLicence']
};
</script>
